import request from '../../utils/request-extra';

const post = request().post;
const apiMap = {
    image: `${window.location.origin}/api/upload/picture.ajax`,
    video: `${window.location.origin}/api/upload/video`,
    file: `${window.location.origin}/kit/mss/upload`
};

export async function imageUpload(params) {
    let apiImg = apiMap.image;
    let paramsData = params;
    // 如果需要返回图片的MD5，则在请求的时候添加参数needMd5
    if (params.needMd5) {
        apiImg = apiMap.video;
        paramsData.fileName = params.file && params.file.name;
    }
    return post(apiImg, paramsData, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

export function videoUpload(params) {
    return post(apiMap.video, params, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

export function fileUpload(params) {
    return post(apiMap.file, params, {
        headers: {
            'Content-Type': 'multipart/form-data'
        }
    });
}

export { apiMap };
